import boardOfDirectors from '../components/boardOfDirectors/Index'
import RouterGuard from './_RouterGuards'
import store from '../store'

export default {
  boardOfDirectorsIndex: {
    path: '/board-of-directors',
    name: 'Board of Directors',
    component: boardOfDirectors,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasBOD)
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/boardOfDirectors.js